import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
@Injectable()
export class BlockExplorerService {

  constructor(private http: Http, private router: Router) { }

  public OnGetContract() {
    // total number of contracts
    return this.http.get(environment.explorerUrl + '/explorer/chaincodes').map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
  public OnGetLatestBlock() {
    // GET Latest block number
    return this.http.get(environment.explorerUrl + '/explorer/chaininfo').map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
  public OnGetActiveNode() {
    return this.http.get(environment.explorerUrl + '/activeNodes').map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
  public OnGetAllTransactions() {
    // last three blocks
    return this.http.get(environment.explorerUrl + '/explorer/threehash').map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
}

